import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import queryString from "query-string";

import IntroScreen from "apps/phone_verification/components/IntroScreen";
import VerificationScreen from "apps/phone_verification/components/VerificationScreen";
import * as Api from "apps/phone_verification/util/web";

import OkCSSLoader from "shared/components/OkCSSLoader";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import FeedbackBanner from "shared/util/FeedbackBanner";
import isApp from "shared/util/isApp";
import AppPhoneCommand from "shared/util/AppPhoneCommand";

import "./App.scss";

const PhoneVerification = ({ onComplete, otherUserId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [currentScreen, setCurrentScreen] = useState(PhoneVerification.screen.IntroScreen);

	const [phoneNumber, setPhoneNumber] = useState("");
	const [verificationCode, setVerificationCode] = useState("");
	let screen = null;

	if (isLoading) {
		screen = (
			<OkCSSLoader show />
		);
	} else if (currentScreen === PhoneVerification.screen.IntroScreen) {
		const onNext = () => {
			setIsLoading(true);

			return Api.startValidation({ phoneNumber }).then(() => {
				setCurrentScreen(PhoneVerification.screen.VerificationScreen);
				setIsLoading(false);
			}).catch(() => {
				setIsLoading(false);

				FeedbackBanner.open({
					message: _str("Sorry, we had trouble sending you a verification code. Please try again."),
					type: "error",
					timeout: 4000,
				});
			});
		};

		screen = (
			<IntroScreen
				phoneNumber={phoneNumber}
				setPhoneNumber={setPhoneNumber}
				onNext={onNext}
			/>
		);
	} else if (currentScreen === PhoneVerification.screen.VerificationScreen) {
		const onNext = () => {
			setIsLoading(true);

			return Api.completeValidation({ verificationCode, otherUserId }).then(() => {
				setCurrentScreen(PhoneVerification.screen.SuccessScreen);
				setIsLoading(false);

				setTimeout(() => {
					if (isApp()) {
						AppPhoneCommand("dismissModal");
					} else if (onComplete) {
						onComplete();
					}
				});
			}).catch(() => {
				setIsLoading(false);

				FeedbackBanner.open({
					message: _str("Sorry, we could not validate your code. Please try again."),
					type: "error",
					timeout: 4000,
				});
			});
		};

		screen = (
			<VerificationScreen
				verificationCode={verificationCode}
				setVerificationCode={setVerificationCode}
				onNext={onNext}
				onBack={() => setCurrentScreen(PhoneVerification.screen.IntroScreen)}
			/>
		);
	} else if (currentScreen === PhoneVerification.screen.SuccessScreen) {
		screen = (
			<h3 className="phone-verification-title">
				<Str>
					{"You're all set 🎉"}
				</Str>
			</h3>
		);
	}

	return (
		<div className={classnames(
			"phone-verification",
			{
				"phone-verification--loading": isLoading
			},
			"oknf",
			"oknf--gray"
		)}>
			{screen}
		</div>
	);
};

PhoneVerification.propTypes = {
	onComplete: PropTypes.func,
	otherUserId: PropTypes.string,
};

const { otherUserId } = queryString.parse(window.location.search);
PhoneVerification.defaultProps = {
	onComplete: null,
	otherUserId: otherUserId,
};

PhoneVerification.screen = {
	IntroScreen: "IntroScreen",
	VerificationScreen: "VerificationScreen",
	SuccessScreen: "SuccessScreen",
};

export default PhoneVerification;



// WEBPACK FOOTER //
// ./src/apps/phone_verification/App.jsx